import client from './client'

export interface JahisMasterPresetsResponse {
  presets: string[]
}

export interface JahisMasterSendRequest {
  preset_name: string
}

export interface JahisMasterSendResponse {
  success: boolean
  sent_jahis_id: string
  filename: string
  preset_name: string
  rp_count: number
}

/**
 * 利用可能なプリセット一覧を取得
 */
export const getJahisMasterPresets =
  async (): Promise<JahisMasterPresetsResponse> => {
    const response = await client.get<JahisMasterPresetsResponse>(
      '/api/jahis-master/presets/'
    )
    return response.data
  }

/**
 * プリセットからJAHIS CSVを生成してSentJahisに保存
 */
export const sendJahisMaster = async (
  request: JahisMasterSendRequest
): Promise<JahisMasterSendResponse> => {
  const response = await client.post<JahisMasterSendResponse>(
    '/api/jahis-master/send/',
    request
  )
  return response.data
}
